/* eslint-disable react/no-string-refs */
import { autobind } from 'core-decorators';
import React from 'react';
import Article from 'app/blocks/article/article';
import { Layout, Title, WhiteBlock } from 'app/blocks/blocks';
import { Button, PrimaryButton } from 'app/blocks/buttons/buttons';
import { processing, tryCatch } from 'app/blocks/common/decorators';
import * as middlewareC from 'app/blocks/middleware/middleware';
import * as middlewareRequestOO from 'app/blocks/middleware/request-oo';
import { Input2 } from 'app/ui/form/inputs';
import './index.scss';

@autobind
class OrdersRequestOO extends React.Component {
    state = {
        isLoading: true,
        ArticleAndJournal: {},
        isSending: false,
        isCanceling: false,
        output: {
            text: '',
        },
    };

    @tryCatch
    @processing('isLoading')
    async componentDidMount() {
        this.setState({
            ArticleAndJournal: await middlewareC.product.getArticleAndJournal(this.props.articleId),
        });
    }

    cancel() {
        this.props.gotoDashboard();
    }

    @tryCatch
    @processing('isSending')
    async send() {
        await middlewareRequestOO.makeRequest(this.props.articleId, this.state.output.text);

        this.props.gotoDashboard();
    }

    isSendPossible() {
        return this.state.output.text;
    }

    render() {
        const { article, journal } = this.state.ArticleAndJournal;

        return (
            <div className="container">
                <Title>Request OnlineOpen</Title>
                <Layout isLoading={this.state.isLoading}>
                    <div className="row m-btm_md">
                        <div className="col-lg-7">
                            <WhiteBlock className="page">
                                <Article article={article} journal={journal} seleniumid="request-oo-" />
                            </WhiteBlock>
                        </div>
                    </div>
                    <div className="row m-btm_md">
                        <div className="col-lg-7">
                            <WhiteBlock className="page">
                                <h5 data-seleniumid="request-oo-panel-title">
                                    Send OnlineOpen Request to Corresponding Author
                                </h5>
                                <div className="border_top" />
                                <span
                                    className="orders_request-oo_Textarea__label"
                                    data-seleniumid="request-oo-textarea-label"
                                >
                                    Message to Corresponding Author
                                </span>
                                <Input2
                                    ref="textarea"
                                    className="orders_request-oo_Textarea m-top_mini"
                                    data-seleniumid="request-oo-text-input"
                                    onChange={value => this.setState({ output: { text: value } })}
                                    rows="10"
                                    type="textarea"
                                    value={this.state.output.text}
                                />
                            </WhiteBlock>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="m-top_md">
                                <div className="pull-left">
                                    <Button data-seleniumid="request-oo-cancel-button" onClick={this.cancel}>
                                        {this.state.isCanceling ? 'Canceling...' : 'Cancel'}
                                    </Button>
                                </div>

                                <div className="pull-right">
                                    <PrimaryButton
                                        data-seleniumid="request-oo-send-button"
                                        disabled={!this.isSendPossible() || this.state.isSending}
                                        onClick={this.send}
                                    >
                                        {this.state.isSending ? 'Sending...' : 'Send'}
                                    </PrimaryButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </Layout>
            </div>
        );
    }
}

export default OrdersRequestOO;
